"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _ReadyToLearnCard = require("./ReadyToLearnCard/ReadyToLearnCard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Global components
 * By Bhargav Shivaprasad <bshivaprasad@svb.com> (www.svb.com)
 * Summary
 * This component renders an SVB Ready to Learn
 */

/**
 * SVBReadyToLearn
 * @param componentTitle: main title of the component
 * @param initialCardTitle: first card main title
 * @param initialCardDescription: first card description
 * @param initialCardHeaderTitle: first card second title
 * @param cardsData: array of objects consisting of title, image, description
 * @returns Ready to Learn HTML with content
 */
const SVBReadyToLearn = props => {
  var _props$componentTitle, _props$initialCardHea, _props$initialCardTit, _props$initialCardDes, _props$cardsData;
  const componentTitle = (_props$componentTitle = props === null || props === void 0 ? void 0 : props.componentTitle) !== null && _props$componentTitle !== void 0 ? _props$componentTitle : "";
  const initialCardHeaderTitle = (_props$initialCardHea = props === null || props === void 0 ? void 0 : props.initialCardHeaderTitle) !== null && _props$initialCardHea !== void 0 ? _props$initialCardHea : "";
  const initialCardTitle = (_props$initialCardTit = props === null || props === void 0 ? void 0 : props.initialCardTitle) !== null && _props$initialCardTit !== void 0 ? _props$initialCardTit : "";
  const initialCardDescription = (_props$initialCardDes = props === null || props === void 0 ? void 0 : props.initialCardDescription) !== null && _props$initialCardDes !== void 0 ? _props$initialCardDes : "";
  const cardsData = (_props$cardsData = props === null || props === void 0 ? void 0 : props.cardsData) !== null && _props$cardsData !== void 0 ? _props$cardsData : [];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pb-4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: " d-flex flex-column align-items-center"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "heading-xxlarge readyToLearn-main-title-color font-family-roboto"
  }, componentTitle), /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-items-center text-align-center mt-2 readyToLearn-title-highlighter"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: ""
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "heading-medium-large fw-bold readyToLearn-first-title-color"
  }, initialCardHeaderTitle), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h1", {
    className: "fw-bold heading-xxlarge rl-font-black"
  }, initialCardTitle), /*#__PURE__*/_react.default.createElement("p", {
    className: "paragraph font-family-roboto pt-3 rl-font-black"
  }, initialCardDescription)))), (cardsData === null || cardsData === void 0 ? void 0 : cardsData.length) > 0 && (cardsData === null || cardsData === void 0 ? void 0 : cardsData.map(item => {
    var _item$title, _item$description, _item$image, _item$learnMoreText, _item$learnMoreLink;
    const title = (_item$title = item === null || item === void 0 ? void 0 : item.title) !== null && _item$title !== void 0 ? _item$title : "";
    const description = (_item$description = item === null || item === void 0 ? void 0 : item.description) !== null && _item$description !== void 0 ? _item$description : "";
    const image = (_item$image = item === null || item === void 0 ? void 0 : item.image) !== null && _item$image !== void 0 ? _item$image : "";
    const learnMoreText = (_item$learnMoreText = item === null || item === void 0 ? void 0 : item.learnMoreText) !== null && _item$learnMoreText !== void 0 ? _item$learnMoreText : "";
    const learnMoreLink = (_item$learnMoreLink = item === null || item === void 0 ? void 0 : item.learnMoreLink) !== null && _item$learnMoreLink !== void 0 ? _item$learnMoreLink : "";
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "col-md"
    }, /*#__PURE__*/_react.default.createElement(_ReadyToLearnCard.ReadyToLearnCard, {
      title: title,
      description: description,
      image: image,
      learnMoreText: learnMoreText,
      learnMoreLink: learnMoreLink
    }));
  }))));
};
var _default = SVBReadyToLearn;
exports.default = _default;